/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { FindSuccessorsSearchRequestDto } from '../models';
// @ts-ignore
import type { GetSuccessionSearchFilterRequestDto } from '../models';
// @ts-ignore
import type { GetSuccessorsByPositionRequestDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { PositionSuccessionSummarySearchResultDto } from '../models';
// @ts-ignore
import type { SuccessionDashboardResponseDto } from '../models';
// @ts-ignore
import type { SuccessionFilterByTypeDto } from '../models';
// @ts-ignore
import type { SuccessorForPositionDetailSearchResultDto } from '../models';
// @ts-ignore
import type { SuccessorInCurrentPositionDetailSearchResultDto } from '../models';
// @ts-ignore
import type { SuccessorsSearchResultDto } from '../models';
/**
 * SuccessionSearchRestApi - axios parameter creator
 * @export
 */
export const SuccessionSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liczby liczone są w zakresie widoczności pytającego. Bez wskazanej perspektywy zakresem jest suma wszystkich relacji użytkownika — tak jak dotąd, żeby istniejące ekrany sukcesji nie zmieniły wyników. Wskazanie perspektywy zawęża liczby do niej samej: kto jest jednocześnie przełożonym i HRBP, w podległym obszarze zobaczy wyłącznie obszar HRBP, a nie oba zbiory zsumowane.
         * @summary Get Succession Dashboard
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Get successors dashboard request
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionDashboard: async (getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSuccessionSearchFilterRequestDto' is not null or undefined
            assertParamExists('getSuccessionDashboard', 'getSuccessionSearchFilterRequestDto', getSuccessionSearchFilterRequestDto)
            const localVarPath = `/api/v2/successions/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSuccessionSearchFilterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Succession Search Filters
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionSearchFilters: async (lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/successions/search-filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (for current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsDetailForPositions: async (pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getSuccessorsDetailForPositions', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSuccessorsDetailForPositions', 'page', page)
            // verify required parameter 'getSuccessorsByPositionRequestDto' is not null or undefined
            assertParamExists('getSuccessorsDetailForPositions', 'getSuccessorsByPositionRequestDto', getSuccessorsByPositionRequestDto)
            const localVarPath = `/api/v2/successions/successors/search-for-current-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSuccessorsByPositionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (in current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsDetailInCurrentPositions: async (pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getSuccessorsDetailInCurrentPositions', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSuccessorsDetailInCurrentPositions', 'page', page)
            // verify required parameter 'getSuccessorsByPositionRequestDto' is not null or undefined
            assertParamExists('getSuccessorsDetailInCurrentPositions', 'getSuccessorsByPositionRequestDto', getSuccessorsByPositionRequestDto)
            const localVarPath = `/api/v2/successions/successors/search-in-current-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSuccessorsByPositionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find successors for current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors for current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsForPositions: async (pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getSuccessorsForPositions', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSuccessorsForPositions', 'page', page)
            // verify required parameter 'getSuccessionSearchFilterRequestDto' is not null or undefined
            assertParamExists('getSuccessorsForPositions', 'getSuccessionSearchFilterRequestDto', getSuccessionSearchFilterRequestDto)
            const localVarPath = `/api/v2/successions/search-for-current-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSuccessionSearchFilterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find successors in current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors in current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsInCurrentPositions: async (pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getSuccessorsInCurrentPositions', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSuccessorsInCurrentPositions', 'page', page)
            // verify required parameter 'getSuccessionSearchFilterRequestDto' is not null or undefined
            assertParamExists('getSuccessorsInCurrentPositions', 'getSuccessionSearchFilterRequestDto', getSuccessionSearchFilterRequestDto)
            const localVarPath = `/api/v2/successions/search-in-current-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSuccessionSearchFilterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Successors
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindSuccessorsSearchRequestDto} findSuccessorsSearchRequestDto Find successors search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuccessors: async (pageSize: number, page: number, findSuccessorsSearchRequestDto: FindSuccessorsSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchSuccessors', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchSuccessors', 'page', page)
            // verify required parameter 'findSuccessorsSearchRequestDto' is not null or undefined
            assertParamExists('searchSuccessors', 'findSuccessorsSearchRequestDto', findSuccessorsSearchRequestDto)
            const localVarPath = `/api/v2/successions/successors-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findSuccessorsSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessionSearchRestApi - functional programming interface
 * @export
 */
export const SuccessionSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessionSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Liczby liczone są w zakresie widoczności pytającego. Bez wskazanej perspektywy zakresem jest suma wszystkich relacji użytkownika — tak jak dotąd, żeby istniejące ekrany sukcesji nie zmieniły wyników. Wskazanie perspektywy zawęża liczby do niej samej: kto jest jednocześnie przełożonym i HRBP, w podległym obszarze zobaczy wyłącznie obszar HRBP, a nie oba zbiory zsumowane.
         * @summary Get Succession Dashboard
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Get successors dashboard request
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessionDashboard(getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessionDashboardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessionDashboard(getSuccessionSearchFilterRequestDto, lang, accessType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessionDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Succession Search Filters
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessionSearchFilters(lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuccessionFilterByTypeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessionSearchFilters(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessionSearchFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (for current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessorsDetailForPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessorForPositionDetailSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessorsDetailForPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessorsDetailForPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (in current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessorsDetailInCurrentPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessorInCurrentPositionDetailSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessorsDetailInCurrentPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessorsDetailInCurrentPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find successors for current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors for current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessorsForPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionSuccessionSummarySearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessorsForPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessorsForPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Find successors in current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors in current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessorsInCurrentPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionSuccessionSummarySearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessorsInCurrentPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.getSuccessorsInCurrentPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Successors
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindSuccessorsSearchRequestDto} findSuccessorsSearchRequestDto Find successors search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSuccessors(pageSize: number, page: number, findSuccessorsSearchRequestDto: FindSuccessorsSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessorsSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSuccessors(pageSize, page, findSuccessorsSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessionSearchRestApi.searchSuccessors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessionSearchRestApi - factory interface
 * @export
 */
export const SuccessionSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessionSearchRestApiFp(configuration)
    return {
        /**
         * Liczby liczone są w zakresie widoczności pytającego. Bez wskazanej perspektywy zakresem jest suma wszystkich relacji użytkownika — tak jak dotąd, żeby istniejące ekrany sukcesji nie zmieniły wyników. Wskazanie perspektywy zawęża liczby do niej samej: kto jest jednocześnie przełożonym i HRBP, w podległym obszarze zobaczy wyłącznie obszar HRBP, a nie oba zbiory zsumowane.
         * @summary Get Succession Dashboard
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Get successors dashboard request
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionDashboard(getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessionDashboardResponseDto> {
            return localVarFp.getSuccessionDashboard(getSuccessionSearchFilterRequestDto, lang, accessType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Succession Search Filters
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessionSearchFilters(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuccessionFilterByTypeDto>> {
            return localVarFp.getSuccessionSearchFilters(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (for current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsDetailForPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorForPositionDetailSearchResultDto> {
            return localVarFp.getSuccessorsDetailForPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find paginated successors for a specific position (in current positions mode)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsDetailInCurrentPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorInCurrentPositionDetailSearchResultDto> {
            return localVarFp.getSuccessorsDetailInCurrentPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find successors for current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors for current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsForPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionSuccessionSummarySearchResultDto> {
            return localVarFp.getSuccessorsForPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find successors in current positions
         * @param {number} pageSize 
         * @param {number} page 
         * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors in current positions request
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessorsInCurrentPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionSuccessionSummarySearchResultDto> {
            return localVarFp.getSuccessorsInCurrentPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Successors
         * @param {number} pageSize 
         * @param {number} page 
         * @param {FindSuccessorsSearchRequestDto} findSuccessorsSearchRequestDto Find successors search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuccessors(pageSize: number, page: number, findSuccessorsSearchRequestDto: FindSuccessorsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorsSearchResultDto> {
            return localVarFp.searchSuccessors(pageSize, page, findSuccessorsSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessionSearchRestApi - interface
 * @export
 * @interface SuccessionSearchRestApi
 */
export interface SuccessionSearchRestApiInterface {
    /**
     * Liczby liczone są w zakresie widoczności pytającego. Bez wskazanej perspektywy zakresem jest suma wszystkich relacji użytkownika — tak jak dotąd, żeby istniejące ekrany sukcesji nie zmieniły wyników. Wskazanie perspektywy zawęża liczby do niej samej: kto jest jednocześnie przełożonym i HRBP, w podległym obszarze zobaczy wyłącznie obszar HRBP, a nie oba zbiory zsumowane.
     * @summary Get Succession Dashboard
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Get successors dashboard request
     * @param {LanguageDto} [lang] 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessionDashboard(getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessionDashboardResponseDto>;

    /**
     * 
     * @summary Get Succession Search Filters
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessionSearchFilters(lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuccessionFilterByTypeDto>>;

    /**
     * 
     * @summary Find paginated successors for a specific position (for current positions mode)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessorsDetailForPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorForPositionDetailSearchResultDto>;

    /**
     * 
     * @summary Find paginated successors for a specific position (in current positions mode)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessorsDetailInCurrentPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorInCurrentPositionDetailSearchResultDto>;

    /**
     * 
     * @summary Find successors for current positions
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors for current positions request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessorsForPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionSuccessionSummarySearchResultDto>;

    /**
     * 
     * @summary Find successors in current positions
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors in current positions request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    getSuccessorsInCurrentPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<PositionSuccessionSummarySearchResultDto>;

    /**
     * 
     * @summary Get Successors
     * @param {number} pageSize 
     * @param {number} page 
     * @param {FindSuccessorsSearchRequestDto} findSuccessorsSearchRequestDto Find successors search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApiInterface
     */
    searchSuccessors(pageSize: number, page: number, findSuccessorsSearchRequestDto: FindSuccessorsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SuccessorsSearchResultDto>;

}

/**
 * SuccessionSearchRestApi - object-oriented interface
 * @export
 * @class SuccessionSearchRestApi
 * @extends {BaseAPI}
 */
export class SuccessionSearchRestApi extends BaseAPI implements SuccessionSearchRestApiInterface {
    /**
     * Liczby liczone są w zakresie widoczności pytającego. Bez wskazanej perspektywy zakresem jest suma wszystkich relacji użytkownika — tak jak dotąd, żeby istniejące ekrany sukcesji nie zmieniły wyników. Wskazanie perspektywy zawęża liczby do niej samej: kto jest jednocześnie przełożonym i HRBP, w podległym obszarze zobaczy wyłącznie obszar HRBP, a nie oba zbiory zsumowane.
     * @summary Get Succession Dashboard
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Get successors dashboard request
     * @param {LanguageDto} [lang] 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessionDashboard(getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessionDashboard(getSuccessionSearchFilterRequestDto, lang, accessType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Succession Search Filters
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessionSearchFilters(lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessionSearchFilters(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find paginated successors for a specific position (for current positions mode)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessorsDetailForPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessorsDetailForPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find paginated successors for a specific position (in current positions mode)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessorsByPositionRequestDto} getSuccessorsByPositionRequestDto Get successors detail for a specific position
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessorsDetailInCurrentPositions(pageSize: number, page: number, getSuccessorsByPositionRequestDto: GetSuccessorsByPositionRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessorsDetailInCurrentPositions(pageSize, page, getSuccessorsByPositionRequestDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find successors for current positions
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors for current positions request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessorsForPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessorsForPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find successors in current positions
     * @param {number} pageSize 
     * @param {number} page 
     * @param {GetSuccessionSearchFilterRequestDto} getSuccessionSearchFilterRequestDto Find successors in current positions request
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public getSuccessorsInCurrentPositions(pageSize: number, page: number, getSuccessionSearchFilterRequestDto: GetSuccessionSearchFilterRequestDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).getSuccessorsInCurrentPositions(pageSize, page, getSuccessionSearchFilterRequestDto, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Successors
     * @param {number} pageSize 
     * @param {number} page 
     * @param {FindSuccessorsSearchRequestDto} findSuccessorsSearchRequestDto Find successors search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessionSearchRestApi
     */
    public searchSuccessors(pageSize: number, page: number, findSuccessorsSearchRequestDto: FindSuccessorsSearchRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessionSearchRestApiFp(this.configuration).searchSuccessors(pageSize, page, findSuccessorsSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

